export const ADD_PATIENT_INFO = "ADD_PATIENT_INFO";
export const CLEAR_PATIENT_INFO = "CLEAR_PATIENT_INFO";
export const ADD_PRGM_ARR = "ADD_PRGM_ARR";
export const CLEAR_PRGM_ARR = "CLEAR_PRGM_ARR";
export const ADD_PATIENT_ORG_INFO = "ADD_PATIENT_ORG_INFO";
export const CLEAR_PATIENT_ORG_INFO = "CLEAR_PATIENT_ORG_INFO";
export const ADD_SELECTED_PRGM_INFO = "ADD_SELECTED_PRGM_INFO";
export const CLEAR_SELECTED_PRGM_INFO = "CLEAR_SELECTED_PRGM_INFO";
export const ADD_RPM_PRGM_INFO = "ADD_RPM_PRGM_INFO";
export const CLEAR_RPM_PRGM_INFO = "CLEAR_RPM_PRGM_INFO";
export const CLEAR_PATIENT = "CLEAR_PATIENT";
export const ADD_SELECTED_TRAINING_INFO = "ADD_SELECTED_TRAINING_INFO";
export const CLEAR_SELECTED_TRAINING_INFO = "CLEAR_SELECTED_TRAINING_INFO";
export const ADD_SELECTED_DEVICE_INFO = "ADD_SELECTED_DEVICE_INFO";
export const CLEAR_SELECTED_DEVICE_INFO = "CLEAR_SELECTED_DEVICE_INFO";
export const SET_PATIENT_EHR = "SET_PATIENT_EHR";
export const SET_PATIENT_EHR_ACTIVE_SYNC = "SET_PATIENT_EHR_ACTIVE_SYNC";
export const SET_PATIENT_EHR_SYNC_SIGNAL = "SET_PATIENT_EHR_SYNC_SIGNAL";
export const CLEAR_PATIENT_EHR = "CLEAR_PATIENT_EHR";
